// extracted by mini-css-extract-plugin
export default {"box":"PayLinkModal_box__tH8gU","boxActive":"PayLinkModal_boxActive__c+l4q","circle":"PayLinkModal_circle__hi1dD","circleActive":"PayLinkModal_circleActive__DSWyt"};